import React, {useState, Fragment, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
// import { useForm } from "../Form/index";
import {Dialog, Transition} from '@headlessui/react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import SelectComponent from '../../Selects/SelectComponent';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import ExitForm from '../../ExitFormModal';
import CreateIcon from '@mui/icons-material/Create';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import {Ripple, Tooltip, initTE} from 'tw-elements';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import Datepicker from 'react-tailwindcss-datepicker';
import DownloadDoneRoundedIcon from '@mui/icons-material/DownloadDoneRounded';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import FinalizarQuestionarioModal from './FinalizarQuestionarioModal';
import {finalizarQuestionario} from '../../../pages/requests';

function DrawerFilter({
    questionarioSelecionado,
    showForm,
    setShowForm,
    setEditarQuestionario,

    setGuardarQuestionario,

    onChangeForm,

    setQuestionarioSelecionado,

    filtroNumero,
    setFiltroNumero,
    filtroCliente,
    filtroData,
    setFiltroData,
    filtroDescricao,
    setFiltroDescricao,
    filtroVendedor,
    setFiltroVendedor,
    filtroNegocio,
    setFiltroNegocio,
    setFiltroCliente,
    filtroValidado,
    setFiltroValidado,
    representantes,
    simNao,
}) {
    const {t} = useTranslation();

    const [openExit, setOpenExit] = useState(false);
    const FORMATO_DATA = 'YYYY-MM-DD';

    const [openModalFinalizar, setOpenModalFinalizar] = useState(false);

    const {isCard, setIsCard, openCards, setOpenCards, acessos} = useContext(Context);
    const [isMobile, setIsMobile] = useState(false);

    initTE({Ripple, Tooltip});

    const [state, setState] = useState({right: false});

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const permissao = acessos.find(element => element.funcao == 'GESYCONSCON') ?? {
        apagar: false,
        consultar: false,
        criar: false,
        funcao: 'GESYCONSCON',
        modificar: false,
    };

    const toggleDrawer = (anchor, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };

    function voltar() {
        setShowForm(false);
        setEditarQuestionario(false);
        setQuestionarioSelecionado(null);
    }
    function setFinalizarQuestionario() {
        finalizarQuestionario(questionarioSelecionado.id, lang).then(res => {
            if (res.data.success) {
                toast.success(t('questionarioValidado'), {
                    position: 'top-right',
                    autoClose: 6000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
                voltar();
            } else {
                res.data.errorMessages.map(m =>
                    toast.error(m, {
                        position: 'top-right',
                        autoClose: 5000,
                    }),
                );
            }
        });
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const closeDrawer = anchor => {
        setState({...state, [anchor]: false});
    };

    const list = anchor => (
        <ClickAwayListener onClickAway={() => closeDrawer(anchor)}>
            <Box sx={{width: 320}} role="presentation" className="h-full  bg-white w-80 dark:bg-gray-800">
                <h5 id="drawer-label" className="inline-flex p-4 items-center mb-6 text-base font-semibold text-blue-600 uppercase dark:text-blue-600">
                    <FilterAltIcon className="mr-2" />
                    {t('filtros')}
                </h5>
                <button
                    type="button"
                    data-drawer-hide="drawer-contact"
                    aria-controls="drawer-contact"
                    onClick={() => {
                        closeDrawer(anchor);
                    }}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white">
                    <CloseIcon />
                    <span className="sr-only">Close menu</span>
                </button>
                <div className="mb-6 p-4">
                    <div>
                        <div className=" mt-2">
                            <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                                {t('numero')}
                            </label>
                            <div className="relative mt-2">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroNumero}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                    onChange={e => {
                                        setFiltroNumero(e.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('descricao')}
                            </label>
                            <div className="relative mt-2">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroDescricao}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                    onChange={e => {
                                        setFiltroDescricao(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className=" mt-2">
                            <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                                {t('cliente')}
                            </label>
                            <div className="relative mt-2">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroCliente}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                    onChange={e => {
                                        setFiltroCliente(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('negocio')}
                            </label>
                            <div className="relative mt-2">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    value={filtroNegocio}
                                    className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                    onChange={e => {
                                        setFiltroNegocio(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('data')}
                            </label>
                            <Datepicker
                                displayFormat={FORMATO_DATA}
                                useRange={false}
                                asSingle={false}
                                value={filtroData}
                                onChange={newValue => {
                                    setFiltroData(newValue);
                                }}
                                inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('vendedor')}
                            </label>
                            <SelectComponent
                                options={representantes}
                                value={filtroVendedor}
                                onChange={e => {
                                    setFiltroVendedor(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtro')}
                            />
                        </div>
                        <div className=" mt-4">
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('validado')}
                            </label>
                            <SelectComponent
                                options={simNao}
                                value={filtroValidado}
                                onChange={e => {
                                    setFiltroValidado(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtro')}
                            />
                        </div>
                    </div>
                </div>
            </Box>
        </ClickAwayListener>
    );
    return (
        <>
            <ToastContainer />
            <div className="flex flex-row items-center">
                {!showForm && !isMobile && (
                    <>
                        <div className="flex items-center mr-3">
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" checked={isCard} onChange={() => setIsCard(!isCard)} className="sr-only peer" />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('modoCard')}</span>
                            </label>
                        </div>
                    </>
                )}
                {(isCard || showForm || isMobile) && (
                    <div className="flex items-center mr-3">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={openCards} onChange={() => setOpenCards(!openCards)} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('abrirCards')}</span>
                        </label>
                    </div>
                )}

                <div className="inline-flex mb-4 rounded-[8px] shadow-sm" role="group">
                    {/* Botao do filtros */}

                    {/* Botao do filtros */}
                    {!showForm && (
                        <button
                            title={t('filtros')}
                            type="button"
                            onClick={toggleDrawer('right', true)}
                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-200 rounded-[8px] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white">
                            <FilterAltIcon />
                        </button>
                    )}

                    {/* Botão de voltar */}
                    {showForm && (
                        <button
                            title={t('voltar')}
                            type="button"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200  hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-blue-700 text-blue-700 focus:ring-blue-700 focus:ring-2 rounded-l-[8px] dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-500 dark:focus:text-white`}
                            onClick={() => {
                                if (onChangeForm) {
                                    setOpenExit(true);
                                } else {
                                    voltar();
                                }
                            }}>
                            {<KeyboardBackspaceRoundedIcon />}
                        </button>
                    )}
                    {/* Botão para finalizar*/}
                    {showForm && (
                        <button
                            title={t('finalizar')}
                            type="submit"
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border border-gray-200 focus:z-10 dark:bg-gray-700 dark:border-gray-600 dark:text-white   dark:focus:ring-blue-500 dark:focus:text-white 
                            ${questionarioSelecionado.validado || !permissao.modificar ? 'cursor-not-allowed' : ' dark:hover:bg-blue-500 hover:bg-gray-100 dark:hover:text-white hover:text-blue-700'}
                            
                            `}
                            onClick={() => {
                                setOpenModalFinalizar(!openModalFinalizar);
                            }}
                            disabled={questionarioSelecionado.validado || !permissao.modificar}>
                            {<DownloadDoneRoundedIcon />}
                        </button>
                    )}

                    {/* Botão de salvar */}
                    {showForm && (
                        <button
                            title={t('salvar')}
                            type="submit"
                            onClick={() => {
                                if (!questionarioSelecionado.validado || !permissao.modificar) setGuardarQuestionario(true);
                            }}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium  bg-white border rounded-r-[8px] border-gray-200 dark:bg-gray-700 dark:border-gray-600 dark:text-white  dark:focus:ring-blue-500 dark:focus:text-white focus:z-10 ${
                                questionarioSelecionado.validado || !permissao.modificar ? 'cursor-not-allowed' : ' hover:bg-gray-100 hover:text-blue-700  dark:hover:text-white dark:hover:bg-blue-500'
                            }`}
                            disabled={questionarioSelecionado.validado || !permissao.modificar}>
                            <SaveIcon />
                        </button>
                    )}
                </div>
            </div>
            <Drawer anchor="right" open={state['right']} onClose={toggleDrawer('right', false)}>
                {list('right')}
            </Drawer>

            {openExit && (
                <ExitForm
                    cancelar={() => setOpenExit(false)}
                    back={() => {
                        voltar();
                        setOpenExit(false);
                    }}
                />
            )}

            {openModalFinalizar && (
                <FinalizarQuestionarioModal
                    cancelar={() => setOpenModalFinalizar(false)}
                    finalizar={() => {
                        setOpenModalFinalizar(false);
                        setFinalizarQuestionario();
                    }}
                />
            )}
        </>
    );
}

export default DrawerFilter;
